import Image, { StaticImageData } from 'next/image';

export const FeatureCard = ({
  icon,
  title,
  description,
  className = '',
}: {
  icon: StaticImageData;
  title: string;
  description: string;
  className?: string;
}) => (
  <div
    className={`mt-10 w-auto md:w-1/2 lg:w-auto rounded-[32px] border-[0.787px] border-[#E5F4F2] bg-white px-4 py-[30px] text-black shadow-sm md:px-12 md:py-10 lg:p-6 xl:px-16 xl:py-10 ${className}`}
  >
    <div className='flex flex-col items-center gap-[14px] md:flex-row'>
      <div className='size-[56px] items-center justify-center rounded-lg border border-[#ECEBFF] p-2'>
        <Image
          loader={(option) => option.src}
          src={icon}
          width={56}
          height={56}
          alt='icon'
        />
      </div>
      <h3 className='text-center text-base font-bold text-[#2D2D2D] md:text-left lg:text-2xl'>
        {title}
      </h3>
    </div>
    <p className='mt-4 text-center text-sm leading-6 font-medium text-[#2D2D2D] md:text-left xl:text-base'>
      {description}
    </p>
  </div>
);
